import React, {Component, useRef} from 'react'

import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import PCodeItem from './module/pCodeItem'

import * as Actions from "../../../../store/modules/code";
import * as FActions from "../../../../store/modules/footer";

import * as func from "../../../../utils/functions";

import {PropTypes} from "prop-types";
import {getParams, pushUrl} from "../../../../utils/functions";

class ParentCode extends Component {
	constructor(props) {
		super(props);

		this.state = {
			editIndex : ''
		}

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onReload = this.onReload.bind(this);
		this.changeView = this.changeView.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.onChildCode = this.onChildCode.bind(this);
	}

	onInsert() {
		const insertRecord = {
			'code_id': '',
			'code_name': '',
			'code_desc': '',
			'code_name_eng': '',
			'del_yn': "N",
			'depth_level': 0,
			'disp_yn': "Y",
			'up_code_id': '',
			'map_code': '',
			'visible_seq': 1,
			'is_edit': true,
		}
		const parentRecords = [...this.props.parentRecords];
		if (parentRecords.length > 0 && parentRecords[0].code_id === '') {
			this.showMessage('추가해주세요.')
		} else {
			this.onEditIndex(0);
			parentRecords.unshift(insertRecord);
			this.props.dataActions.setCode({'parentRecords': parentRecords});
		}
	}

	onEditIndex(id) {
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		this.setState({
			'editIndex' : id
		})
	}

	onUpdate(index, record) {
		const parentRecords = [...this.props.parentRecords];
		parentRecords[index] = record;
		this.props.dataActions.setCode({'parentRecords': parentRecords});
	}

	onReload() {
		func.getData("code/search", this.props.param).then((response) => {
			response.parentRecords = response.records;
			delete response.records;
			this.props.dataActions.setCode(response);
		});
	}

	onRemove(index) {
		const parentRecords = [...this.props.parentRecords];
		parentRecords.splice(index, 1);
		this.props.dataActions.setCode({'parentRecords': parentRecords});
	}

	changeView() {
		let param = this.props.param;
		if (param.del_yn === 'Y') {
			param.del_yn = 'N';
		} else if (param.del_yn === 'N') {
			param.del_yn = 'Y';
		}

		func.getData("code/search", param).then((response) => {
			this.props.dataActions.setCode({"param": param});
			response.parentRecords = response.records;
			delete response.records;
			this.props.dataActions.setCode(response);
		});
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	onChildCode(code_id) {
		if(this.props.selectChildCodeId !== code_id) {
			func.getData("code/search/" + code_id, {}).then((response) => {
				if(response.records)
					response.childRecords = response.records;
				else
					response.childRecords = [];
				delete response.records;
				response.selectChildCodeId = code_id;

				const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;
				pushUrl('코드', 'admin.php?page=researchmind-type&tab_id='+activeTabID + '&code=' + code_id, null);

				this.props.dataActions.setCode(response);
			});
		}
	}

	render() {
		const {parentRecords} = this.props;

		return (
			<div className="p-0">
				<div className="d-flex justify-content-end mb-1">
					<button type="button" className="btn btn-sm btn-warning mr-1" onClick={this.changeView}>
						{this.props.param.del_yn === 'Y' ? '삭제내역 닫기' : '삭제내역 보기'}</button>
					{this.props.param.del_yn !== 'Y' &&
					<button type="button" className="btn btn-sm btn-primary" onClick={this.onInsert}>추가</button>
					}
				</div>
				<div className="card mt-0 p-0 scrollY600x">
					<table className="table table-thin border-bottom mb-0">
						<colgroup>
							<col width="50%"/>
							<col width="50%"/>
							{this.props.param.del_yn !== 'Y' &&
							<col width="100px"/>
							}
						</colgroup>
						<thead>
						<tr>
							<th scope="col">코드ID</th>
							<th scope="col">코드명</th>
							{this.props.param.del_yn !== 'Y' &&
							<th scope="col">액션</th>
							}
						</tr>
						</thead>
						<tbody>
						{parentRecords.map((record, index) => {
							return (
								<PCodeItem
									key={record.code_id}
									index={record.code_id}
									ref={"ref" + record.code_id}
									arrIndex={index}
									record={record}
									onUpdate={this.onUpdate}
									onRemove={this.onRemove}
									onReload={this.onReload}
									onEditIndex={this.onEditIndex}
									showMessage={this.showMessage}
									onChildCode={this.onChildCode}
									delYn={this.props.param.del_yn}
									selectChildCodeId={this.props.selectChildCodeId}
								/>
							)
						})}
						</tbody>
					</table>
				</div>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		param: state.code.param ? state.code.param : {},
		parentRecords: state.code.parentRecords ? state.code.parentRecords : [],
		selectChildCodeId: state.code.selectChildCodeId ? state.code.selectChildCodeId : '',
		// isPopup1: state.code.isPopup1 ? state.code.isPopup1 : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(ParentCode)

// ParentCode.propTypes = {
// 	param: PropTypes.object,
// 	parentRecords: PropTypes.array,
// 	// facet: PropTypes.object,
// 	// totalRecords: PropTypes.number,
// 	// totalPage: PropTypes.number,
// };
